/*
 * Base is the default environment for production.
 */
export default function baseEnv(baseApi: string, tenant: string) {
    return {
        route: {
            baseRoute: "/",
        },
        api: {
            currentVersion: `${baseApi}/v1`,
            utenteLoginGet: `${baseApi}/v1/Auth/Authenticate`,
            utenteLogout: `${baseApi}/v1/Auth/Logout`,
            authenticate: `${baseApi}/v1/Auth/Authenticate`,
            authenticateExternal: `${baseApi}/v1/Auth/ExternalAuthenticate`,
            lookupManagementGet: `${baseApi}/v1/Lookup/LookupManagement`,
            lookupAgentiProvvigionaliGet: `${baseApi}/v1/collaborations/GetAgents`,
            lookupCanaliGet: `${baseApi}/v1/Lookup/LookupChannels`,
            lookupCanaliAdminGet: `${baseApi}/v1/Lookup/LookupChannelsAdmin`,
            lookupSegmentiGet: `${baseApi}/v1/Lookup/LookupSegments`,
            lookupProdottiGet: `${baseApi}/v1/Lookup/LookupProducts`,
            lookupAdministrativeCategoryGet: `${baseApi}/v1/Lookup/LookupAdministrativeCategory`,
            lookupDocumentTypesGet: `${baseApi}/v1/Lookup/LookupDocumentTypes`,
            lookupProductTypesGet: `${baseApi}/v1/Lookup/LookupProductTypes`,
            lookupAuthorityTypesGet: `${baseApi}/v1/Lookup/LookupAuthorityTypes`,
            lookupRequestedTypeGet: `${baseApi}/v1/Lookup/LookupRequestedType`,
            lookupConvenzioniGet: `${baseApi}/v1/Lookup/LookupConventions`,
            lookUpNazioniGet: `${baseApi}/v1/Lookup/LookupNations`,
            lookUpComuniGet: `${baseApi}/v1/Lookup/LookupPlaces`,
            lookupAddressTypesGet: `${baseApi}/v1/Lookup/LookupAddressTypes`,
            simulazioniGet: `${baseApi}/v1/Simulator/GetLatestSimulation`,
            simulazioniCreditoNetGet: `${baseApi}/v1/Simulator/CreditoNet`,
            simulazioniCreditoNetDettaglioGet: `${baseApi}/v1/Simulator/CreditoNetDetail`,
            simulazioniRichiestaCedibilitaGet: `${baseApi}/v1/Simulator/TransferRequest`,
            simulazioniRichiestaCedibilitaDetaglioGet: `${baseApi}/v1/Simulator/TransferRequestDetail`,
            documentiInfoGet: `${baseApi}/v1/Documents/GetDocumentsInfo`,
            documentiUpload: `${baseApi}/v1/Documents/Upload`,
            documentiDelete: `${baseApi}/v1/Documents/Delete`,
            documentiGenerate: `${baseApi}/v1/Documents/Generate`,
            documentiDownload: `${baseApi}/v1/Documents/Download`,
            documentiStaticiDownload: `${baseApi}/v1/Documents/DownloadStatic`,
            estimate: `${baseApi}/v1/Estimator/SaveOrUpdate`,
            sign: `${baseApi}/v1/Sign/sign/start-process`,
            signStatus: `${baseApi}/v1/Sign/sign/status-process`,
            signCancel: `${baseApi}/v1/Sign/sign/cancel-process`,
            expiringEstimateNotification: `${baseApi}/v1/Notifications/GetExpiringEstimateNotifications`,
            digitalSignedDocumentsNotification: `${baseApi}/v1/Notifications/GetDigitalSignedDocumentsNotifications`,
            appointmentNotification: `${baseApi}/v1/Notifications/GetAppointmentNotifications`,
            estimateNote: `${baseApi}/v1/Note/GetEstimateNote`,
            addNote: `${baseApi}/v1/Note/AddNote`,
            getTopicNotes: `${baseApi}/v1/Note/getTopicNotes`,
            setEstimateNotesAsRead: `${baseApi}/v1/Note/SetEstimateNotesAsRead`,
            practice: `${baseApi}/v1/Practice/Save`,
            searchEntities: `${baseApi}/v1/Search/SearchEntities`,
            simulate: `${baseApi}/v1/Simulator/Simulate`,
            assicurazioniGet: `${baseApi}/v1/Simulator/Insurances`,
            salvaSimulazione: `${baseApi}/v1/Simulator/Save`,
            ricalcolaSimulazione: `${baseApi}/v1/Simulator/Recalculation`,
            calculateTaegTeg: `${baseApi}/v1/Simulator/TegTaeg`,
            searchSimulations: `${baseApi}/v1/Simulator/SearchSimulations`,
            findSimulation: `${baseApi}/v1/Simulator/FindSimulation`,
            resumeSimulation: `${baseApi}/v1/Simulator/ResumeSimulation`,
            simulazioniExportExcel: `${baseApi}/v1/Simulator/ExportXls`,
            lookupTipoSimulazioneGet: `${baseApi}/v1/Simulazione/getTipo`,
            configSpendingReview: `${baseApi}/v1/Simulator/getVersionSpendingReview`,
            searchEstimates: `${baseApi}/v1/Estimator/SearchEstimates`,
            findEstimate: `${baseApi}/v1/Estimator/FindEstimate`,
            printEstimate: `${baseApi}/v1/Estimator/PrintEstimate`,
            preventiviExportExcel: `${baseApi}/v1/Estimator/ExportXls`,
            saveAppointment: `${baseApi}/v1/Appointments/Save`,
            getAppointment: `${baseApi}/v1/Appointments/GetAppointments`,
            deleteAppointment: `${baseApi}/v1/Appointments/Delete`,
            refreshToken: `${baseApi}/v1/Auth/RefreshToken`,
            contenutoGet: `${baseApi}/v1/contenuto`,
            traduzione: `${baseApi}/v1/traduzione`,
            errorExample: "https://httpstat.us/520",
            integration: `${baseApi}/v1/Integration/Get`,
            searchAnagCqCrm: `${baseApi}/v1/Integration/SearchAnagCqCrm`,
            existsAnagCqCrmOutVisibility: `${baseApi}/v1/Integration/ExistsAnagOutOfVisibility`,
            userInfo: `${baseApi}/v1/Auth/GetUserInfo`,
            userRoles: `${baseApi}/v1/Auth/GetUserRoles`,
            lookupSubLevels: `${baseApi}/v1/Lookup/LookupSubLevels`,
            // login: `${baseApi}/login`,
            // contents: `${baseApi}/contents/:sectionId`,
            // content: `${baseApi}/content/:contentId`,
        },
        lang: "it-IT",
        isProduction: true,
        isDevelopment: false,
        isTesting: false,
        accessTokenName: "ccq-access-token",
        refreshTokenName: "ccq-refresh-token",
        descUoName: "desc-uo",
        codAgency: "cod-agency",
        recaptchaValidation: true,
        recaptchaV2Key: "6LfhztkZAAAAAJbwUOEg_N4li2UdKcu1qKY-aOFV",
        recaptchaV2InvisibleKey: "6LcwztkZAAAAAMmO3XQ784t5UqguwlaEFhbHrvH6",
        recaptchaV3Key: "6LdkztkZAAAAABgxbCW-FsDzxGApdRacs3B8tWzF",
        codTipoRichiedentePensionato: "P",
        codTipoRichiedenteDipendentePrivato: "DPR",
        codTipoRichiedenteDipendentePubblico: "DPU",
        uploadFileSizeLimit: 2097152, // 2mb
        uploadFileAcceptedTypes: [".jpg", ".png", ".pdf", ".doc", ".docx"],
        numeroElementiPerPaginaTabella: 10,
        minDate: "1800-01-01",
        tenant: `${tenant}`,
        defaultIdSubLevel: "-1",
        defaultIdPracticeType: "0",
    };
}

export type Environment = ReturnType<typeof baseEnv>;
